<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('主播名称')" prop="nickName">
                <a-input
                  v-model="queryParam.nickName"
                  :maxLength="32"
                  :placeholder="$t('通用.输入.请输入') + $t('主播名称')"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('工会')" prop="tradeId">
                <a-select v-model="queryParam.tradeId" placeholder="请选择工会">
                  <a-select-option v-for="item in tradeList" :value="item.id">{{ item.unionName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="status">
                <a-select v-model="queryParam.status" placeholder="请选择审核状态">
                  <a-select-option v-for="item in dict.type['trade_audit_status']" :value="item.value">{{
                    item.label
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"
                  ><a-icon type="search" />{{ $t('通用.按钮.查询') }}</a-button
                >
                <a-button style="margin-left: 8px" @click="resetQuery"
                  ><a-icon type="redo" />{{ $t('通用.按钮.重置') }}</a-button
                >
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['trade:applytradeunion:add']">
          <a-icon type="plus" />{{ $t('通用.按钮.新增') }}</a-button>
        </a-button> -->
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['trade:applytradeunion:edit']"
        >
          <a-icon type="edit" />{{ $t('通用.按钮.修改') }}
        </a-button>
        <!-- <a-button
          type="danger"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['trade:applytradeunion:remove']"
        >
          <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
        </a-button> -->
        <a-button type="primary" @click="handleExport" v-hasPermi="['trade:applytradeunion:export']">
          <a-icon type="download" />{{ $t('通用.按钮.导出') }}
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="status" slot-scope="text, record">
          {{ dict.type['trade_audit_status'].filter((item) => item.value === text + '')[0].label || '-' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <!-- <a-divider type="vertical" v-hasPermi="['trade:apply/trade/union:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['trade:apply/trade/union:edit']">
            <a-icon type="edit" />{{ $t('通用.按钮.修改') }}
          </a> -->
          <a-divider
            type="vertical"
            v-hasPermi="['trade:apply/trade/union:audit']"
            v-if="isAdmin && record.status == 2"
          />
          <a
            @click="handleAudit(record)"
            v-hasPermi="['trade:apply/trade/union:audit']"
            v-if="isAdmin && record.status == 2"
          >
            {{ $t('审核') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['trade:apply/trade/union:audit']" />
          <a
            @click="handleUnBind(record)"
            v-if="record.status == 4 && record.bindingStatus == 0"
            v-hasPermi="['trade:apply/trade/union:audit']"
          >
            {{ $t('解约') }}
          </a>
          <!-- <a-divider type="vertical" v-hasPermi="['trade:apply/trade/union:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['trade:apply/trade/union:remove']">
            <a-icon type="delete" />{{ $t('通用.按钮.删除') }}
          </a> -->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <a-modal title="审核" :visible="visible" @ok="handleOk" @cancel="handleCancel" width="40vw">
      <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="真实姓名">
          <a-input v-model="form.realName" :maxLength="50" disabled="true" />
        </a-form-model-item>
        <a-form-model-item label="身份证号">
          <a-input v-model="form.idCard" :maxLength="50" disabled="true" />
        </a-form-model-item>
        <a-form-model-item label="身份证人像面">
          <OssUploadSingle v-model="form.idCardFace" type="img" :maxSize="300"></OssUploadSingle>
        </a-form-model-item>

        <a-form-model-item label="身份证国徽面">
          <OssUploadSingle v-model="form.idCardCountry" type="img" :maxSize="300"></OssUploadSingle>
        </a-form-model-item>
        <a-form-model-item label="结果">
          <a-radio-group v-model="form.status" button-style="solid">
            <a-radio-button value="1"> 通过 </a-radio-button>
            <a-radio-button value="0"> 拒绝 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="拒绝原因" :required="form.status == 0 ? true : false">
          <a-textarea v-model="form.reason" placeholder="请输入拒绝原因"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import {
  pageApplyTradeUnion,
  listApplyTradeUnion,
  updateApplyTradeUnion,
  delApplyTradeUnion,
  bingAudit,
  unBingAudit,
} from '@/api/trade/applyTradeUnion'
import { getUser } from '@/api/biz/user'
import { listTradeUnion } from '@/api/trade/tradeUnion'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'

export default {
  name: 'ApplyTradeUnion',
  components: {
    CustomDictTag,
    CreateForm,
    OssUploadSingle,
  },
  mixins: [tableMixin],
  dicts: ['trade_audit_status'],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      visible: false,
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: undefined,
        tradeId: undefined,
        status: undefined,
        bindingStatus: undefined,
        reasonPlatform: undefined,
        reasonTrade: undefined,
        erminationStatus: undefined,
        erminationReason: undefined,
        pageNum: 1,
        pageSize: 10,
        nickName: null,
      },
      columns: [
        {
          title: this.$t('主播名称'),
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('主播真实姓名'),
          dataIndex: 'realName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('所属工会'),
          dataIndex: 'unionName',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: this.$t('平台审核失败原因'),
          dataIndex: 'reasonPlatform',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('工会审核失败原因'),
          dataIndex: 'reasonTrade',
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('申请时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        id: undefined,
        status: undefined,
        reason: undefined,
        oldStatus: undefined,
        reasonPlatform: undefined,
        reasonTrade: undefined,
      },
      tradeList: [],
      userInfo: this.$store.state.user,
      isAdmin: true,
    }
  },
  filters: {},
  created() {
    let ghIndex = this.userInfo.roles.findIndex((r) => r === 'gonghui')
    if (ghIndex > -1) {
      this.isAdmin = true
    }
    this.getTradeList()
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询主播申请绑定工会记录列表 */
    getList() {
      this.loading = true
      pageApplyTradeUnion(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        userId: undefined,
        tradeId: undefined,
        status: undefined,
        bindingStatus: undefined,
        reasonPlatform: undefined,
        reasonTrade: undefined,
        erminationStatus: undefined,
        erminationReason: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    getTradeList() {
      listTradeUnion().then((response) => {
        this.tradeList = response.data
      })
    },

    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delApplyTradeUnion(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            const message = that.$t('通用.文本.删除成功')
            that.$message.success(message, 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download(
            'trade/apply/trade/union/export',
            ...that.queryParam,
            `主播申请绑定工会记录_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
    handleAudit(record) {
      this.form = {
        id: record.id,
        oldStatus: record.status,
      }
      getUser({ id: record.userId }).then((response) => {
        this.form = response.data
        this.form.applyId = record.id
      })
      this.visible = true
    },
    handleOk() {
      let data = {
        id: this.form.applyId,
        status: this.form.status,
        reason: this.form.reason,
      }
      bingAudit(data).then(() => {
        this.getList()
        this.visible = false
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleUnBind(record) {
      this.$confirm({
        title: this.$t('确定对主播【' + record.nickName + '】进行解约吗？'),
        onOk() {
          let data = {
            id: record.id,
            status: 1,
          }
          return unBingAudit(data).then(() => {
            that.getList()
            const message = that.$t('成功')
            that.$message.success(message, 3)
          })
        },
        onCancel() {},
      })
    },
  },
}
</script>